import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import { Container, Row, Col ,Form, Button  } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './contactus.css';
import { useNavigate } from 'react-router-dom';

// Import images using ES6 import syntax
import Background from '../../Assets/contact.png';

const ContactUs = () => {
  // Create a reference for the form
  const form = useRef();
  const navigate = useNavigate();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        'service_yyue87h',
        'template_e9n6lec',
        form.current, // Use form reference here
        'lZgr1WL2eRXIIZXqf'
      )
      .then(
        (result) => {
          form.current.reset(); // Reset the form
          navigate("/success"); // Navigate to success page
        },
        (error) => {
          alert("Message failed to send. Please try again.");
          console.error("EmailJS error:", error.text);
        }
      );
  };

  return (
    <div id="contact" className="contactbackground">
      <Row>
        <div className="contactus-section">
          <h1>Contact us</h1>
        </div>

        <Col xs={12} md={6} lg={6}>
          <div className="contacttext">
            <p>
               Karama Shopping Center
              <br /> Dubai,
              <br/> United Arab Emirates
            </p>
            <p>
              Tel: +971567257579
              <br />
              Email: support@piercingserviceuae.com
            </p>
          </div>

          <div className="contacttext">
            <h1>STORE LOCATION</h1>

            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3608.7554147741084!2d55.3028873!3d25.2451617!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f43a048702db1%3A0x225eed1d310adb75!2sPiercing%20service%20uae!5e0!3m2!1sen!2sin!4v1729664865233!5m2!1sen!2sin"
              className="w-100 h-100"
              allowFullScreen=""
              loading="lazy"
            ></iframe>


          </div>
          <div className="contacttext">
            <p>Copyright © 2025 Piercing Service UAE</p>
          </div>
        </Col>

        <Col xs={12} md={6} lg={6}>
          <div className="contacttext">
          <form ref={form} onSubmit={sendEmail}>
            <div className="form-group">
              <label htmlFor="firstname">First Name</label>
              <input type="text" id="firstname" name="firstname" required />
            </div>
            <div className="form-group">
              <label htmlFor="lastname">Last Name</label>
              <input type="text" id="lastname" name="lastname" required />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input type="email" id="email" name="email" required />
            </div>
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea id="message" name="message" required></textarea>
            </div>
            <div className="form-group">
              <button type="submit">Send Message</button>
            </div>
          </form>
          </div>
          <div className="contacttext2">
            <p>Privacy policy Terms and condition</p>
          </div>
        </Col>

        <div className="contactus-icons">
          <a
            href="https://www.twitter.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={require('../../Assets/icon_x.png')}
              className=""
              alt="Twitter"
            />
          </a>
          <a
            href="https://www.instagram.com/piercing_service_uae"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={require('../../Assets/icon_ig.png')}
              className=""
              alt="Instagram"
            />
          </a>
          <a
            href="https://www.facebook.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={require('../../Assets/icon_fb.png')}
              className=""
              alt="Facebook"
            />
          </a>
        </div>
      </Row>
    </div>
  );
};

export default ContactUs;
